import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    SET_DOCUMENT_TYPES: null,
  },
  'DocumentTypes',
);
